// app/javascript/application.js

import "@hotwired/turbo-rails"
import "./controllers"
import "bootstrap/dist/js/bootstrap.bundle"

import AOS from "aos"
import "aos/dist/aos.css"

import GLightbox from "glightbox"
import "glightbox/dist/css/glightbox.css"

console.log("app/javascript/application.js")

document.addEventListener("turbo:load", () => {

  // --- AOS ---
  AOS.init({
    duration: 900,
    easing: "ease-in-out",
    once: false,
    mirror: false
  })

  // --- Gallery Lightbox ---
  if (document.querySelector(".js-lightbox")) {
    GLightbox({
      selector: ".js-lightbox",
      touchNavigation: true,
      loop: true,
      draggable: true,
      zoomable: false
    })
  }
  
  const isTouch = window.matchMedia("(pointer: coarse)").matches
  const eventType = isTouch ? "pointerup" : "click"

  document.querySelectorAll(".gallery__lane").forEach(lane => {
    const links = lane.querySelectorAll(".gallery__link")
    const items = []
    const seen = new Set()

    // --- items生成（重複排除） ---
    links.forEach(link => {
      const img = link.querySelector("img")
      const index = link.dataset.realIndex

      if (!img || seen.has(index)) return
      seen.add(index)
      items.push({
	href: img.src,
	title: link.dataset.title || "",
	description: link.dataset.description || ""
      })
    })

    // --- タップ判定用 ---
    let startX = 0
    let startY = 0
    links.forEach(link => {
      // 押した位置を記録
      link.addEventListener("pointerdown", e => {
	startX = e.clientX
	startY = e.clientY
      })

      // 離したとき（tap or click）
      link.addEventListener(eventType, e => {
	e.preventDefault()
	const dx = Math.abs(e.clientX - startX)
	const dy = Math.abs(e.clientY - startY)
	// 少しでも動いてたら「タップじゃない」
	if (dx > 8 || dy > 8) return
	const index = parseInt(link.dataset.realIndex, 10)
	const lightbox = GLightbox({
          elements: items,
          loop: false,
          touchNavigation: true,
          draggable: true,
          zoomable: false
	})

	lightbox.openAt(index)
      })
    })
  })

  // --- #therapist ---
  if (window.location.hash === "#therapist") {
    window.scrollTo(0, 0)

    setTimeout(() => {
      const section = document.querySelector("#therapist")
      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start"
        })
      }
    }, 800)
  }

})
